





































import * as R from 'ramda';
import VueI18n from 'vue-i18n';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DeleteCriticalDataDialog extends Vue {
  @Prop()
  private dialogTitle!: VueI18n.TranslateResult;

  @Prop({ required: false, default: true })
  private additionalValidation!: boolean;

  private dialog: boolean = true;

  @Emit('pressed-cancel-btn')
  private emitCancelBtnAction() {}

  @Emit('pressed-delete-btn')
  private emitDeleteBtnAction() {}

  private get canDelete() {
    return this.additionalValidation;
  }
}
